import { Mutation } from 'app/types/mutation'
import { gql } from 'graphql-request'

export const blockMutation = () => gql`
  mutation toggleBlock($id: String!) {
    block(id: $id) {
      id
      success
      reason
    }
  }
`

export const blockResult = (data: any) => {
  return data.block as Mutation
}
